import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
  SoundbarSetOne01: 'SoundbarSetOne01_TVConsole',
  SoundbarSetOne02: 'SoundbarSetOne02_StorageBox',
  SoundbarSetOne03: 'SoundbarSetOne03_MagazineRack',
  SoundbarSetOne04: 'SoundbarSetOne04_Bookshelf',
  SoundbarSetOne05: 'SoundbarSetOne05_Desk Shelf',
  SoundbarSetOne06: 'SoundbarSetOne06_CatTunnel',
  SoundbarSetOne07: 'SoundbarSetOne07_PolarBear',
  SoundbarSetOne08: 'SoundbarSetOne08_SeaTurtle',
  SoundbarSetOne09: 'SoundbarSetOne09_Twist',
  SoundbarSetOne10: 'SoundbarSetOne10_AlexCouchArmTable',
  SoundbarSetOne11: 'SoundbarSetOne11_KinokoTable',
  SoundbarSetOne12: 'SoundbarSetOne12_TheSoban',
  SoundbarSetOne13: 'SoundbarSetOne13_ToolBox',
};

export default {
  categoryKey: CategoryLists.HomeAudio.list.SoundbarSetOne,
  cover: {
    caption: 'LandingPage.SoundbarSet01',
    backgroundImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mobileCoverImage: require('../../cover_image/cover_DeskStationarySet.jpg'),
    mainImage: {
      src: require('../../../assets/categories/Soundbar set01.png'),
      pcSrc: require('../../../assets/categories/Soundbar set01.png'),
    },
  },
  box: {
    title: 'ProductPage.selectDesign', //i18n
    list: [
      {
        key: ModelKey.SoundbarSetOne06,
        image: {
          mobile: require('../../thumbnail/cat_tunnel.png'),
          pc: require('../../thumbnail/cat_tunnel.png'),
        },
        title: 'ProductPage.CatTunnel', // i18n
        level: 2,
        minutes: 50,
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne04,
        image: {
          mobile: require('../../thumbnail/Book_shelf.png'),
          pc: require('../../thumbnail/Book_shelf.png'),
        },
        title: 'ProductPage.BookShelf', // i18n
        level: 2,
        minutes: 60,
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne05,
        image: {
          mobile: require('../../thumbnail/Desk_shelf.png'),
          pc: require('../../thumbnail/Desk_shelf.png'),
        },
        title: 'ProductPage.DeskShelf', // i18n
        level: 3,
        minutes: 80,
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne02,
        image: {
          mobile: require('../../thumbnail/Storagebox.png'),
          pc: require('../../thumbnail/Storagebox.png'),
        },
        title: 'ProductPage.StorageBox', // i18n
        level: 3,
        minutes: 120,
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne01,
        image: {
          mobile: require('../../thumbnail/tv_console.png'),
          pc: require('../../thumbnail/tv_console.png'),
        },
        title: 'ProductPage.tvConsole', // i18n
        level: 4,
        minutes: 180,
        allowInches: [],
      },

      {
        key: ModelKey.SoundbarSetOne03,
        image: {
          mobile: require('../../thumbnail/Magazine_rack.png'),
          pc: require('../../thumbnail/Magazine_rack.png'),
        },
        title: 'ProductPage.MagazineRack', // i18n
        level: 4,
        minutes: 150,
        allowInches: [],
      },
    ],
  },
  dezeenBox: {
    title: 'ProductPage.selectDesignDezeen', //i18n
    list: [
      {
        key: ModelKey.SoundbarSetOne07,
        image: {
          mobile: require('../../thumbnail/Endangered_Animals_bear.png'),
          pc: require('../../thumbnail/Endangered_Animals_bear.png'),
        },
        title: 'ProductPage.PolarBear', // i18n
        minutes: 55,
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne08,
        image: {
          mobile: require('../../thumbnail/Endangered_Animals_turtle.png'),
          pc: require('../../thumbnail/Endangered_Animals_turtle.png'),
        },
        title: 'ProductPage.SeaTurtle', // i18n
        minutes: 55,
        allowInches: [],
      },
			{
				key: ModelKey.SoundbarSetOne09,
				image: {
				mobile: require('../../thumbnail/Twist.png'),
				pc: require('../../thumbnail/Twist.png'),
			},
				title: 'ProductPage.Twist', // i18n
				allowInches: [],
			},
      {
        key: ModelKey.SoundbarSetOne10,
        image: {
          mobile: require('../../thumbnail/Alex_couch_arm_table.png'),
          pc: require('../../thumbnail/Alex_couch_arm_table.png'),
        },
        title: 'ProductPage.AlexCouchArmTable', // i18n
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne11,
        image: {
          mobile: require('../../thumbnail/Kinokotable.png'),
          pc: require('../../thumbnail/Kinokotable.png'),
        },
        title: 'ProductPage.KinokoTable', // i18n
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne12,
        image: {
          mobile: require('../../thumbnail/TheSoban.png'),
          pc: require('../../thumbnail/TheSoban.png'),
        },
        title: 'ProductPage.TheSoban', // i18n
        allowInches: [],
      },
      {
        key: ModelKey.SoundbarSetOne13,
        image: {
          mobile: require('../../thumbnail/Toolbox.png'),
          pc: require('../../thumbnail/Toolbox.png'),
        },
        title: 'ProductPage.ToolBox', // i18n
        allowInches: [],
      },
    ],
  },
  worldcup:{},
  disney:{},
  ModelKey: ModelKey,
};

export const Boxes = {
  [ModelKey.SoundbarSetOne01]: () => import('./tvconsole'),
  [ModelKey.SoundbarSetOne02]: () => import('./storagebox'),
  [ModelKey.SoundbarSetOne03]: () => import('./magazinerack'),
  [ModelKey.SoundbarSetOne04]: () => import('./bookshelf'),
  [ModelKey.SoundbarSetOne05]: () => import('./deskshelf'),
  [ModelKey.SoundbarSetOne06]: () => import('./cattunnel'),
  [ModelKey.SoundbarSetOne07]: () => import('./polarbear'),
  [ModelKey.SoundbarSetOne08]: () => import('./turtle'),
  [ModelKey.SoundbarSetOne09]: () => import('./twist'),
  [ModelKey.SoundbarSetOne10]: () => import('./armtable'),
  [ModelKey.SoundbarSetOne11]: () => import('./kinokotable'),
  [ModelKey.SoundbarSetOne12]: () => import('./soban'),
  [ModelKey.SoundbarSetOne13]: () => import('./toolbox'),
};
